import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["defaultQuantity", "multiplier", "input"]

  updateDefault() {
    const value = this.defaultQuantityTarget.value
    this.inputTargets.forEach(input => {
      input.value = Math.round(value)
    })
    this.defaultQuantityTarget.value = 0
  }

  updateMultiplier() {
    const value = this.multiplierTarget.value
    this.inputTargets.forEach(input => {
      input.value = Math.round(input.dataset.patientVisits * value)
    })
    this.multiplierTarget.value = 0
  }
}
